
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fleettrackingquotes",
      function () {
        return require("private-next-pages/fleettrackingquotes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fleettrackingquotes"])
      });
    }
  